import axios from './http'

function uploadImage(fileObj){
    let formData = new FormData();
    formData.set("file", fileObj.file);
    const url = '/common/uploadImage';
    return axios.post(url, formData, {headers: {"Content-type": "multipart/form-data"}});
}

function uploadFile(file,  onSuccess, onError, onProgress){
    let formData = new FormData();
    formData.set("file", file);
    const url = '/common/uploadFile';
    return axios.post(url, formData, {
        headers: {"Content-type": "multipart/form-data"},
        onUploadProgress: (progressEvent) => {
        const percent = Math.round((progressEvent.loaded * 100) / progressEvent.total);
        onProgress({ percent: percent }, file);
        }
    })
}

function download(url, data){
    return axios.post(url, data, { responseType: 'blob' }).then((res) => {
        const filename = res.headers['content-disposition']?.split(';')[1].split('=')[1];
        const link = document.createElement('a');
        link.href = URL.createObjectURL(res);
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    })
}

function changeLanguage(id, language) {
    return axios.get('/changeLanguage?id=' + id + "&language=" + language);
}

function modifyPwd(id, oldPwd, newPwd) {
    return axios.get('/modifyPwd?id=' + id + "&oldPwd=" + oldPwd + "&newPwd=" + newPwd);
}

function chooseGame(gameId) {
    return axios.get('/chooseGame?gameId=' + gameId);
}

export default {
    uploadImage,
    download,
    changeLanguage,
    modifyPwd,
    chooseGame,
    uploadFile
}